// ─────────────────────────────────────────────────────────────────────────────
// HarnessRunControl.tsx — BUCK'S ADAPTER onto the shared run control.
//
// Reads nothing of its own: the runner comes from the ONE shared poll
// (`agentRunStore`), the offered presses from `resolveRunControl` via
// `useAgentRun`, and the surface from `runSurface.buckSurface`. RUN and STOP
// fire only what that view offers — this file never decides that a press is
// available.
//
// Renders nothing for an agent with no work harness, exactly as `RunStrip` did.
// ─────────────────────────────────────────────────────────────────────────────

import React, { useSyncExternalStore } from 'react';
import { useAgentRun } from './AgentRunControl';
import RunControlBar from './RunControlBar';
import { getRunner, subscribe } from '../../state/agentRunStore';
import { buckSurface } from '../../lib/runSurface';

export default function HarnessRunControl(
  { domain, agent, testId = 'harness-run-control' }: { domain: string; agent: string | null; testId?: string },
) {
  const { view, isHarness, press, pressAlso } = useAgentRun(domain, agent, true, true);
  const runner = useSyncExternalStore(subscribe, getRunner);
  if (!isHarness) return null;

  const surface = buckSurface({ runner, view });
  const fire = (what: 'arm' | 'stop') =>
    view.actionable && view.action === what ? press
      : view.alsoOffers === what ? pressAlso : undefined;

  return (
    <RunControlBar
      surface={surface}
      onRun={fire('arm')}
      onStop={fire('stop')}
      sending={view.tone === 'pending'}
      testId={testId}
    />
  );
}
